import Slider from '@ui/Slider/component'

export default function (): void {
  Slider('#cms-push', {
    speed: 1000,
    slidesPerView: 'auto',
    pagination: {
      el: '#cms-push-slider-pagination',
    },
    spaceBetween: 16,
  })

  Slider('#cms-top-destination', {
    speed: 1000,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '#cms-top-destination-slider-next',
      prevEl: '#cms-top-destination-slider-prev',
    },
    pagination: {
      el: '#cms-top-destination-slider-pagination',
    },
    spaceBetween: 16,
  })
}
